import clsx from 'clsx';
import { ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react';
import styles from './button.module.css';

type Props = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const Button: FC<Props> = ({
  children,
  className: inClassName,
  type = 'button',
  ...props
}) => {
  const className = clsx(
    styles.btn,
    'bg-brand-black leading-normal h-max text-brand-gray-3 hover:text-brand-white disabled:text-brand-gray-6 border-brand-gray-1 disabled:border-brand-gray-6 disabled:cursor-not-allowed rounded border py-2 px-6 hover:border-transparent focus:ring',
    inClassName,
  );

  return (
    <button className={className} type={type} {...props}>
      {children}
    </button>
  );
};

export { Button };
